import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { playDing } from "@/lib/push";

const DAY = 24 * 60 * 60 * 1000;
const sentKey = (uid) => `gs_near_sent_${uid}`;
const readSent = (uid) => { try { return JSON.parse(localStorage.getItem(sentKey(uid)) || "{}"); } catch { return {}; } };
const fmt = (m) => (m < 1000 ? `${m} m` : `${(m / 1000).toFixed(1)} km`);
const moved = (a, lat, lng) => Math.hypot((a.lat - lat) * 111000, (a.lng - lng) * 111000 * Math.cos((lat * Math.PI) / 180));

async function systemNotify(b, link) {
  if (!("Notification" in window) || Notification.permission !== "granted" || !navigator.serviceWorker) return;
  const reg = await navigator.serviceWorker.getRegistration("/push-sw.js") || await navigator.serviceWorker.ready;
  reg?.showNotification(`${b.title} është afër teje`, { body: `${fmt(b.meters)} larg${b.city ? " · " + b.city : ""} — prek për ta hapur`, icon: b.image || "/logo192.png", tag: `near-${b.id}`, data: { link } });
}

export function ProximityWatcher() {
  const { user } = useAuth();
  const nav = useNavigate();
  const last = useRef(null);
  const on = !!(user && user.notify_nearby);
  const radius = (user && user.nearby_radius) || 1000;
  const uid = user && (user.id || user._id);

  useEffect(() => {
    if (!on || !navigator.geolocation) return;
    const check = async ({ coords: { latitude: lat, longitude: lng } }) => {
      const p = last.current;
      if (p && Date.now() - p.t < 15000 && moved(p, lat, lng) < 40) return;
      last.current = { lat, lng, t: Date.now() };
      const { data } = await api.get("/proximity", { params: { lat, lng, radius } }).catch(() => ({ data: null }));
      if (!data) return;
      const sent = readSent(uid);
      const now = Date.now();
      Object.keys(sent).forEach((k) => { if (now - sent[k] > DAY) delete sent[k]; });
      const fresh = data.filter((b) => b.inside && !sent[b.id]).slice(0, 3);
      fresh.forEach((b) => { sent[b.id] = now; });
      localStorage.setItem(sentKey(uid), JSON.stringify(sent));
      fresh.forEach((b) => {
        const link = `/shpallje/${b.id}`;
        playDing();
        systemNotify(b, link).catch(() => {});
        toast(`${b.title} është afër teje`, { description: `${fmt(b.meters)} larg`, duration: 10000, action: { label: "Hape", onClick: () => nav(link) } });
      });
    };
    const id = navigator.geolocation.watchPosition(check, () => {}, { enableHighAccuracy: true, maximumAge: 10000, timeout: 30000 });
    return () => navigator.geolocation.clearWatch(id);
  }, [on, radius, nav, uid]);

  return null;
}
